import type { GA4AnalyticsEvent } from '@/domain/shared/types';

export interface HeaderClickEventProps {
  hasChildren?: boolean;
  result: string[];
}

export function createHeaderClickEvent({ hasChildren, result }: HeaderClickEventProps): GA4AnalyticsEvent {
  const resultsTreeString = result ? result.join(' > ') : '';
  const itemClicked = result?.[result.length - 1];
  const isFinalLink = !hasChildren;
  return {
    event: 'mainMenu',
    description: `Item in main menu is clicked: ${itemClicked}`,
    element: 'Clickable text',
    type: `Final link: ${isFinalLink}`,
    result: resultsTreeString?.toString().toLowerCase(),
    interaction: true,
  };
}
interface AccountHeaderEventProps {
  description: string;
  result: string;
}

export function createAccountHeaderClickEvent({ description, result }: AccountHeaderEventProps): GA4AnalyticsEvent {
  return {
    event: 'manageAccount',
    description,
    element: 'button',
    result,
    interaction: true,
  };
}

interface LoggedUserEventProps {
  loggedIn: boolean;
  userId: string;
}

export function createLoggedUserEvent({
  loggedIn,
  userId,
}: LoggedUserEventProps): Partial<GA4AnalyticsEvent> & { logged_in: boolean; userId: string } {
  return {
    event: 'logged_in_check',
    logged_in: loggedIn,
    userId,
  };
}
